import { graphql } from '@mp/graphql/generated';
import { type ResultOf } from '@graphql-typed-document-node/core';
import { useGraphQLQuery } from '@mp/hooks/useGraphQLRequest';

export const ShiftSwapJobFragmentGql = graphql(`
  fragment ShiftSwapJobFragment on Job {
    id
    starts_date
    starts_time
    ends_time
    positions {
      display_name
    }
    location {
      timezone_lookup
    }
  }
`);

const ShiftSwapsGql = graphql(`
  query GetShiftSwaps($input: ShiftRequestQueryInput) {
    shiftRequests(input: $input) {
      id
      job_id
      job {
        starts_date
        ...ShiftSwapJobFragment
      }
      requester_id
      status
    }
  }
`);

export type ShiftSwapsProps = ResultOf<typeof ShiftSwapsGql>;

export const getShiftSwaps = ({ accountId }: { accountId?: number | null }) => {
  const { data, isLoading } = useGraphQLQuery<ShiftSwapsProps>({
    operationName: 'GetShiftSwaps',
    query: ShiftSwapsGql,
    enabled: !!accountId,
    variables: {
      input: {
        statuses: ['pending_requestee'],
        request_types: ['swap'],
        requestee_account_id: accountId,
      },
    },
  });

  const shiftRequests = data?.shiftRequests ?? [];

  return { shiftRequests, isLoading };
};
